const style = () => ({
  title: {
    fontSize: 18,
    '@media screen and (min-height: 400px) and (max-height: 706px)': {
      fontSize: 16,
    },
  },
  expandIcon: {
    marginLeft: -12,
    marginRight: 6,
    transition: 'transform linear 0.1s',
    transform: 'rotate(0deg)',
    '&.isOpen': {
      transform: 'rotate(90deg)',
    },
  },
  foldersContainer: {
    padding: 20,
    height: '100%',
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',
    '@media screen and (min-height: 400px) and (max-height: 706px)': {
      padding: '0 8px',
    },
  },
  folderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 12,
    padding: '6px 8px',
    borderRadius: 5,
    '&:hover': {
      background: '#FAFCFF',
    },
    '&:hover $editButton': {
      display: 'block',
    },
    '&.dropFolder': {
      background: '#EEF1FA',
    },
    // '&.dynamicFolder': {
    //   '&:hover $folderTotal': {
    //     display: 'none',
    //   },
    // },
  },
  folderItem: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    maxWidth: '95%',
  },
  folderName: {
    fontSize: 14,
    marginLeft: 6,
  },
  folderTotal: {
    display: 'block',
    padding: 2,
    width: 18,
    textAlign: 'center',
    background: '#EDF1FB',
    color: '#B5BFDA',
    fontSize: 11,
    borderRadius: 4,
    marginLeft: 12,
  },
  divider: {
    background: '#EAEAEA',
    height: 1,
    width: '100%',
    paddingLeft: '40px',
    marginLeft: '-20px',
    marginTop: 20,
    marginBottom: 20,
    '&.galleryMode': {
      marginLeft: 0,
      paddingLeft: 0,
    },
  },
  editButton: {
    display: 'none',
    fontSize: 12,
    color: '#B4BFD9',
    cursor: 'pointer',
  },
  folderNameDetail: {
    fontSize: 14,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: '#75798A',
    '&.selected': {
      color: '#373737',
    },
  },
})

export default style
